import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackHotjarEvent, trackHotjarRoute } from '@lib/index';

const normalizePath = (path: string) => path
  .replace(/\/\d+/g, '/:id')
  .replace(/\/[0-9a-fA-F-]{20,}/g, '/:id');

const toEventName = (path: string) => {
  const normalizedPath = normalizePath(path).replace(/^\/+/, '') || 'home';
  return `view_${normalizedPath.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '')}`;
};

const HotjarRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = normalizePath(location.pathname);
    const route = `${pathname}${location.search}`;

    trackHotjarRoute(route);
    trackHotjarEvent(toEventName(location.pathname));
  }, [location.pathname, location.search]);

  return null;
};

export default HotjarRouteTracker;
